import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import CrudForm from '../../crud/CrudForm'
import { myuserService as service } from '../../../services'

const initElement = {
    email: '',
    pass: '',
    name: '',
    lastname: '',
    isClient: false,
    rol: { code: null, name: '' },
    enable: true,
    picture: null,
}

type FormAdministratorParms = {
    id: string
}

export default function FormMyAccount() {
    const [objectform, setObjectform] = React.useState({ ...initElement })
    let { id } = useParams<FormAdministratorParms>()
    const [idRow, setIdrow] = useState(id ? Number(id) : 0)

    const estructureform = [
        {
            type: 'input',
            name: 'email',
            readonly: idRow > 0 ? true : false,
            col: 4,
        },
        {
            type: 'input',
            name: 'name',
            col: 4,
        },
        {
            type: 'title',
            name: 'streettitle',
            col: 12,
        },
        {
            type: 'input',
            name: 'street',
            col: 4,
        },
        {
            type: 'input',
            name: 'number',
            col: 2,
        },
        {
            type: 'input',
            name: 'floor',
            col: 2,
        },
        {
            type: 'input',
            name: 'door',
            col: 2,
        },
        {
            type: 'input',
            name: 'city',
            col: 4,
        },
        {
            type: 'input',
            name: 'state',
            col: 4,
        },
        {
            type: 'input',
            name: 'cp',
            col: 4,
        },
        {
            type: 'input',
            name: 'country',
            col: 4,
        },
    ]

    const recoveryElement = function (objectedit, element) {
        objectedit['email'] = element.email ? element.email : ''
        objectedit['name'] = element.name ? element.name : ''
        objectedit['lastname'] = element.lastname ? element.lastname : ''
        objectedit['rol'] = {
            code: element.rol && element.rol.code ? element.rol.code : null,
            name: element.rol && element.rol.name ? element.rol.name : null,
        }
        objectedit['laundry'] = {
            id:
                element.laundry && element.laundry.id
                    ? element.laundry.id
                    : null,
            name:
                element.laundry && element.laundry.name
                    ? element.laundry.name
                    : null,
        }
        objectedit['picture'] = element.picture ? element.picture : ''

        return objectedit
    }

    const isValid = function (object) {
        if (!object['name']) {
            return 'Debe indicar el nombre'
        }
        if (!object['email']) {
            return 'Debe indicar el email'
        }

        return null
    }

    return (
        <>
            <CrudForm
                objectform={{ ...initElement }}
                estructureform={estructureform}
                i18n={'myaccount'}
                urledit={'/administrator/edit/'}
                urlCancel={'/administrator'}
                service={service}
                recoveryElement={recoveryElement}
                valid={isValid}
            />
        </>
    )
}
